import React from "react";

const CurrentVsProposedHorizontalDivider: React.FC = () => {
    return(
        <hr className={"current_proposed-horizontal-divider"}/>
    )
}

export default CurrentVsProposedHorizontalDivider;